import { call, put, takeLatest } from 'redux-saga/effects';
import { getJSON } from '../../shared/util';

function* init() {
    const transits = yield call(getJSON, '/api/product/planet-tracker');

    yield put({
        type: 'planet-tracker:update',
        payload: {
            data: { transits },
        },
    });
}

export function* root() {
    yield takeLatest('planet-tracker:init', init);
}
